import { ProductWidget, UserModel, userDataCompleted } from '@vestico/model';

export const userDataCompletedForAnyProduct = (products: ProductWidget[] | undefined, user: UserModel) => {
  return !!products?.map((product) => !!product && userDataCompleted(user, product?.matchingCategory, false, true)).reduce((a, b) => a || b, false);
};
